module.exports = __webpack_public_path__ + "static/media/company.ab100672.svg";